import { Button, Grid, TextField, Typography } from '@mui/material';
import { FormikValues } from 'formik';
import { ComponentType, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { BaseDialog } from '../../dialogs';
import { FIELD_DESCRIPTION, FIELD_ID } from './appeals-confirm-schema';
import { useAppealsConfirm } from './useAppealsConfirm';

interface AppealsConfirmDialogProps {
  title?: string;
  text?: string;
  id: string | number;
  popDialog?: any;
  onSubmit: (values: FormikValues) => void;
}

export const AppealsConfirmDialog: ComponentType<AppealsConfirmDialogProps> = ({
  title: dialogTitle,
  text,
  id,
  popDialog,
  onSubmit,
  ...props
}) => {
  const { t } = useTranslation();
  const { formik, handleFieldChange, hasError, getErrorMessage } = useAppealsConfirm({ onSubmit });

  const title = dialogTitle ? dialogTitle : t('appeal.confirm.title', 'Одобрить апелляцию');

  useEffect(() => {
    formik.setFieldValue(FIELD_ID, id);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [id]);

  return (
    <BaseDialog {...{ ...props, popDialog, title }}>
      {text && (
        <Typography variant="h5" component="p" mb={4}>
          {text}
        </Typography>
      )}
      <form onSubmit={formik.handleSubmit}>
        <Grid container mb={4} direction="column" spacing={1}>
          {/* <Grid item>
            <TextField
              {...formik.getFieldProps(FIELD_POINT)}
              // onChange={(e: any) => handleFieldChange(FIELD_POINT, e)}
              error={hasError(FIELD_POINT)}
              helperText={getErrorMessage(FIELD_POINT)}
              label={t('add.point', 'Добавить баллы')}
              placeholder={t('add.point.placeholder', 'Введите количество баллов')}
              fullWidth
              type="number"
              InputProps={{ inputProps: { min: 0 } }}
            />
          </Grid> */}
          <Grid item>
            <TextField
              {...formik.getFieldProps(FIELD_DESCRIPTION)}
              onChange={(e: any) => handleFieldChange(FIELD_DESCRIPTION, e)}
              error={hasError(FIELD_DESCRIPTION)}
              helperText={getErrorMessage(FIELD_DESCRIPTION)}
              label={t('appeal.confirm.reason.label', 'Причина подтверждения апелляции')}
              placeholder={t('appeal.decline.explanation.placeholder', 'Введите причину...')}
              fullWidth
              multiline
              rows={4}
            />
          </Grid>
        </Grid>
        <Grid container columnSpacing={2} justifyContent="flex-end">
          <Grid item xs={6}>
            <Button
              onClick={popDialog}
              variant="outlined"
              size="large"
              fullWidth
              sx={{ minWidth: 0 }}
            >
              {t('cancel', 'Отмена')}
            </Button>
          </Grid>
          <Grid item xs={6}>
            <Button
              type="submit"
              variant="contained"
              color="success"
              size="large"
              fullWidth
              sx={{ minWidth: 0 }}
            >
              {t('action.confirm', 'Одобрить')}
            </Button>
          </Grid>
        </Grid>
      </form>
    </BaseDialog>
  );
};
